<div class="user-access" *ngIf="headerNotification || footerNotification">
  <!-- header notifications -->
  <div class="user-access__header" *ngIf="headerNotification" [ngSwitch]="headerNotification.type">
    <!-- past due -->
    <app-header-notification
      type="warning"
      *ngSwitchCase="gateTypes.ProAccountPastDue"
      (dismissClick)="handleHeaderDismissClick(headerNotification)">
      <div class="text-13 text-medium">
        Your Personal Pro subscription has expired. Please update your
        <span
          class="text-link text-underline"
          [routerLink]="['/account/profile']"
          [queryParams]="{ section: 'subscription', mode: 'edit' }">
          payment information
        </span>
        to keep enjoying full access.
      </div>
    </app-header-notification>
  </div>

  <!-- footer notifications -->
  <div class="user-access__footer" *ngIf="footerNotification" @inFromBottom>
    <!-- dynamic -->
    <app-footer-notification
      [label]="footerNotification.data.title"
      [compact]="(breakpoint$ | async) < breakPoints.Medium"
      [buttonLabel]="footerNotification.data.actionText"
      (actionClick)="handleActionClick(footerNotification.type)"
      (dismissClick)="handleFooterDismissClick(footerNotification)">
    </app-footer-notification>
  </div>
</div>
